const Moment = require("moment");

export default function humanizeDate(timestamp, format = "D MMM YYYY, h:mm A") {
  Moment.relativeTimeThreshold("s", 60);
  Moment.relativeTimeThreshold("m", 60);
  Moment.relativeTimeThreshold("h", 24);
  const utcTime = Moment.utc(timestamp);

  const relativeTime = utcTime.fromNow();

  const startOfDay = Moment().startOf("day");
  return formatTimeStamp(utcTime, relativeTime, startOfDay, format);
}

function formatTimeStamp(utcTime, relativeTime, startOfDay, format) {
  // console.log("time-log : ", utcTime.utcOffset("+05:30").format("D MMM YYYY, h:mm A"));
  return (relativeTime = utcTime.utcOffset("+05:30").format(format));
}

export function schemaFormatByISOString(isoString) {
  if (!isoString) {
    return;
  }

  const timeInMillis = new Date(isoString).getTime();

  return (
    isoString.slice(0, 11) +
    `${new Date(timeInMillis)
      .toLocaleTimeString("en-Us", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      })
      .replace(/ PM| AM/, "+05:30")}`
  );
}
